/**
 * Sigle pentru carousel „Mărci deservite”.
 * Icon‑uri din Simple Icons npm (@16.x).
 * Mercedes‑Benz, Land Rover, Peugeot: SVG în public/resources/car-brands (SVG Repo).
 */
import {
  siVolkswagen,
  siAudi,
  siBmw,
  siOpel,
  siVolvo,
  siToyota,
  siSkoda,
  siSeat,
  siRenault,
  siNissan,
  siMitsubishi,
  siMazda,
  siKia,
  siJeep,
  siHyundai,
  siHonda,
  siFord,
  siFiat,
  siDacia,
} from "simple-icons";

export const carBrandsMarquee = [
  { name: "Volkswagen", icon: siVolkswagen },
  { name: "Audi", icon: siAudi },
  { name: "BMW", icon: siBmw },
  { name: "Mercedes-Benz", svgSrc: "/resources/car-brands/mercedes-benz-svgrepo.svg" },
  { name: "Opel", icon: siOpel },
  { name: "Volvo", icon: siVolvo },
  { name: "Toyota", icon: siToyota },
  { name: "Skoda", icon: siSkoda },
  { name: "Seat", icon: siSeat },
  { name: "Renault", icon: siRenault },
  { name: "Peugeot", svgSrc: "/resources/car-brands/peugeot-svgrepo.svg" },
  { name: "Nissan", icon: siNissan },
  { name: "Mitsubishi", icon: siMitsubishi },
  { name: "Mazda", icon: siMazda },
  { name: "Land Rover", svgSrc: "/resources/car-brands/land-rover-svgrepo.svg" },
  { name: "Kia", icon: siKia },
  { name: "Jeep", icon: siJeep },
  { name: "Hyundai", icon: siHyundai },
  { name: "Honda", icon: siHonda },
  { name: "Ford", icon: siFord },
  { name: "Fiat", icon: siFiat },
  { name: "Dacia", icon: siDacia },
];
